import { useState } from 'react';

const defaultProps = {
  ascending: true,
  rows: 10,
  showRowsPerPageDropdown: undefined,
  orderColumn: '',
};

export function usePagination(props: any = {}) {
  props = { ...defaultProps, ...props };

  const DEFAULT_PAGINATOR_STATE = {
    currentPage: 1,
    totalPages: 1,
    rows: props.rows,
    showRowsPerPageDropdown: props.showRowsPerPageDropdown,
  };

  const DEFAULT_PAGINATION_PARAMETERS = {
    order: {
      isAscending: props.ascending,
      orderColumn: props.orderColumn,
    },
    page: {
      index: 1,
      size: props.rows,
    },
  };

  const [paginatorState, setPaginatorState] = useState(DEFAULT_PAGINATOR_STATE);

  const [paginationParameters, setPaginationParameters] = useState(DEFAULT_PAGINATION_PARAMETERS);

  const handlePageChange = (pageNumber) => {
    setPaginatorState((prevState) => ({ ...prevState, currentPage: pageNumber }));
    setPaginationParameters((prevState) => {
      const clone = structuredClone(prevState);
      clone.page.index = pageNumber;
      return clone;
    });
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    setPaginatorState((prevState) => ({ ...prevState, currentPage: 1, rows: rowsPerPage }));
    setPaginationParameters((prevState) => {
      const clone = structuredClone(prevState);
      clone.page.index = 1;
      clone.page.size = rowsPerPage;
      return clone;
    });
  };

  return {
    paginatorState,
    setPaginatorState,
    paginationParameters,
    setPaginationParameters,
    handlePageChange,
    handleRowsPerPageChange,
  };
}
